import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";
import { HttpMethod } from "../../Common/useFetch";
import useUserRequest from "../../Common/useUserRequest";
import { RequestOptions } from "../../Common/useRequest";

const path = (businessId: string) => `/api/businesses/${businessId}/purchaseOrders`;

const useCompletePurchaseOrder = (poId?: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();

  return useUserRequest<void, void>({
    path: `${path(business.id)}/${poId}/complete`,
    method: HttpMethod.POST,
  }, options);
}

export default useCompletePurchaseOrder;
